import { render, staticRenderFns } from "./WidgetCurrentDayJobList.vue?vue&type=template&id=074dc38d"
import script from "./WidgetCurrentDayJobList.vue?vue&type=script&lang=ts"
export * from "./WidgetCurrentDayJobList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports